'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
import { borderLightColor, surfaceLightColor, surfaceDarkColor, borderDarkColor } from "../color.css.js";
import { hasContrast } from "./hasContrast.js";
const getBorderActionFallback = (backgroundColor, context, primaryPalette) => {
  const isOnLight = context === "onLight";
  const surfaceColor = isOnLight ? surfaceLightColor : surfaceDarkColor;
  if (hasContrast(backgroundColor, surfaceColor, true)) return "transparent";
  if (isOnLight) {
    if (hasContrast(backgroundColor, primaryPalette.dark, true))
      return primaryPalette.dark;
    if (hasContrast(backgroundColor, primaryPalette.darkest, true))
      return primaryPalette.darkest;
    if (hasContrast(backgroundColor, borderLightColor, true))
      return borderLightColor;
    return tinycolor.mostReadable(surfaceColor, [borderLightColor, borderDarkColor]).toHexString();
  }
  if (hasContrast(backgroundColor, primaryPalette.base, true))
    return primaryPalette.base;
  if (hasContrast(backgroundColor, primaryPalette.light, true))
    return primaryPalette.light;
  if (hasContrast(backgroundColor, primaryPalette.lightest, true))
    return primaryPalette.lightest;
  if (hasContrast(backgroundColor, borderDarkColor, true))
    return borderDarkColor;
  return tinycolor.mostReadable(surfaceColor, [borderLightColor, borderDarkColor]).toHexString();
};
export {
  getBorderActionFallback
};
